var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB9999AA-A742-41D3-9C71-4DEBDC56814E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chart/VerticalBar",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 L16,0 C15.448,0 15,0.448 15,1 L15,18.997 L14,18.997 L14,7 C14,6.448 13.552,6 13,6 L12,6 C11.448,6 11,6.448 11,7 L11,18.998 L10,18.998 L10,10 C10,9.448 9.552,9 9,9 L8,9 C7.448,9 7,9.448 7,10 L7,18.999 L6,18.999 L6,12 C6,11.448 5.552,11 5,11 L4,11 C3.448,11 3,11.448 3,12 L3,19 L1,19 L1,0 L-1.45661261e-13,0 L-1.45661261e-13,20 L20.07,19.996 L20.07,18.996 L18,18.996 L18,1 C18,0.448 17.552,0 17,0 L17,0 Z M5,12 L5,18.999 L5,18.999 L4,18.999 L4,12 L5,12 L5,12 Z M9,10 L9,18.998 L9,18.998 L8,18.998 L8,10 L9,10 L9,10 Z M13,7 L13,18.997 L13,18.997 L12,18.998 L12,7 L13,7 L13,7 Z M17,1 L17,18.996 L17,18.996 L16,18.997 L16,1 L17,1 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBar);
export default __webpack_public_path__ + "static/media/VerticalBar.60406c0f6c16f39b42fc8d9144b5bab5.svg";
export { ForwardRef as ReactComponent };